import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { SanityImage } from '~/types/sanity'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '280px' }]

export default function ArticleAuthor({
  author,
  authorAvatar,
  className = '',
  releaseDate,
}: {
  author?: string
  authorAvatar?: SanityImage
  className?: string
  releaseDate: string
}): React.ReactElement {
  const { t } = useTranslation('blog')
  const articleDate = new Date(releaseDate).toISOString().split('T')[0]

  return (
    <div className={`flex items-center justify-between w-full text-xs ${className}`}>
      <div className="flex items-center">
        <ResponsiveImage
          alt={t('homAuthor')}
          height={28}
          imageClassName="mr-2 rounded-full drop-shadow-lg"
          imageWidths="280"
          mediaQuery={mediaQuery}
          srcKey={authorAvatar?.srcKey ?? 'logos/house-of-math-sm-grad-bg.svg'}
          width={28}
        />

        <span className="block">{author ?? 'House of Math'}</span>
      </div>
      <time className="text-gray-medium -mr-2" dateTime={releaseDate} title={articleDate}>
        {articleDate}
      </time>
    </div>
  )
}
